interface Props {
  reason: string;
}

export function EngineerJustificationPanel({ reason }: Props) {
  return (
    <div className="rounded-xl border border-border bg-card">
      <div className="border-b border-border px-5 py-3.5">
        <h3 className="text-sm font-semibold text-foreground">Engineer Justification</h3>
      </div>
      <div className="px-5 py-4">
        <p className="whitespace-pre-wrap text-sm text-foreground">{reason}</p>
        <p className="mt-3 text-xs text-muted-foreground">
          Captured as a single free-text field at request time — this system does not split
          justification into separate technical/outcome/risk fields.
        </p>
      </div>
    </div>
  );
}
